import Vue from 'vue'
import i18n from '@/common/i18n/i18n'
// 控制弹窗焦点方法
export function focusFunc (event, dialogName) {
  const _dialog = document.querySelector(dialogName)
  if (!_dialog.contains(event.target)) {
    event.stopPropagation()
    _dialog.focus()
  }
}

/* 图片转base64 */
export function getBase64 (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

export function defaultCurrency (event) {
  if (event.marketCurrency) {
    if (event.marketCurrency?.toLocaleUpperCase() === 'HKD') {
      event.isHK = true
    } else {
      event.isNonHK = true
    }
  } else {
    if (event.currency?.toLocaleUpperCase() === 'HKD') {
      event.isHK = true
    } else {
      event.isNonHK = true
    }
  }
}

export function isPathContainCDT (path, cdtEventIdList) {
  const cdtHostList = ['live.cityline.com', 'liveuat.cityline.com', 'uat.citylinedigitaltheatre.com', 'www.citylinedigitaltheatre.com', 'citylinedigitaltheatre.com']
  try {
    const url = new URL(path)
    if (cdtEventIdList) {
      const urlSearch = new URLSearchParams(url.search)
      const eventId = urlSearch.get('event') || urlSearch.get('eventId')
      if (eventId && cdtEventIdList.includes(Number(eventId))) {
        return true
      }
    }
    return cdtHostList.includes(url.host)
  } catch {
    return cdtHostList.includes(path)
  }
}

// 防抖函数
export function debounce (fn, delay = 500) {
  let timer
  return function () {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn.apply(this, arguments)
    }, delay)
  }
}

// 节流函数
export function throttle (fn, delay = 500) {
  let prev = 0
  return () => {
    const now = Date.now()
    if (now - prev > delay) {
      fn.call(this, ...arguments)
      prev = now
    }
  }
}

// 深拷贝
export function deepClone (obj) {
  const type = toString(obj)
  if (type === 'Object') {
    const res = {}
    for (const key in obj) {
      res[key] = deepClone(obj[key])
    }
    return res
  } else if (type === 'Array') {
    const res = []
    for (const value of obj) {
      res.push(deepClone(value))
    }
    return res
  } else {
    return obj
  }
}

export function toString (val) {
  return Object.prototype.toString.call(val).replace(/^\[object (\S+)\]$/, '$1')
}

export function hasOwnProperty (obj, val) {
  return Object.prototype.hasOwnProperty.call(obj, val)
}

export function padStart (str, number, padStr) {
  return String.prototype.padStart.call(str, number, padStr)
}

export function getI18n (lang) {
  switch (lang) {
    case 'en_US':
      return 'en_US'
    case 'zh_CN':
      return 'zh_CN'
    case 'zh_HK':
    case 'zh_TW':
      return 'zh_HK'
  }
}

/* 获取 event 的 link */
export function getEventLink (event, cdtIdList) {
  if (event.eventType === Vue.prototype.$cdtType || (event.redirectUrl && isPathContainCDT(event.redirectUrl, cdtIdList))) {
    // 属于cdt的数据
    return event.utsvId === -1 ? event.redirectUrl : process.env.VUE_APP_CDT_URL + '/brief?eventId=' + event.utsvId + '&lang=' + i18n.locale
  } else {
    let redirectLang = ''
    if (i18n.locale === 'en_US') {
      redirectLang = 'en'
    } else if (i18n.locale === 'zh_CN') {
      redirectLang = 'CN'
    } else {
      redirectLang = 'TW'
    }
    if (event.redirectUrl.includes('lang=')) {
      return event.redirectUrl.replace(event.redirectUrl.substr(event.redirectUrl.indexOf('lang='), 10), 'lang=' + redirectLang)
    } else {
      if (event.redirectUrl.includes('?')) {
        return event.redirectUrl + '&actionType=5&lang=' + redirectLang
      }
      return event.redirectUrl + '?actionType=5&lang=' + redirectLang
    }
  }
}

/*
  传入一组数据，根据当前时间去查找
  # 新的需求
  1. 找到 startTime 在目前时间之后的数据  allMills
  2. 不符合#1的情况下，找到 endTime 在目前时间之后 allMills
  3. 合并两组数据，寻找距离当前时间最近的值，然后作为下一次刷新的请求的依据

  # 新增，当 hiddenBeforeOnSaleTime = true时，还要加上未来的 on sale time座作为startTime
*/
export function refreshFn (list, fn) {
  // 当前毫秒值
  const currMill = Date.now()
  // 所有符合 #1,#2 的 毫秒值
  const allMills = []
  list.forEach(item => {
    if (item.hiddenBeforeOnSaleTime && item.onSaleTime && item.onSaleTime > currMill) {
      allMills.push(item.onSaleTime)
    }
    if (item.startTime > currMill) {
      allMills.push(item.startTime)
    } else if (item.endTime && item.endTime > currMill) {
      allMills.push(item.endTime)
    }
  })
  if (allMills.length > 0) {
    const minMill = Math.min.apply(Math, allMills)
    /* 最多1天后刷新 */
    const oneDayMill = 1000 * 60 * 60 * 24
    if ((minMill - currMill) > oneDayMill) {
      setTimeout(fn, oneDayMill)
    } else {
      setTimeout(fn, minMill - currMill)
    }
  }
}

/* 根据 field 获取对应的 fieldEng/fieldTc/fieldSc */
export function getField (field) {
  let suffix = ''
  if (i18n.locale === 'en_US') {
    suffix = 'Eng'
  } else if (i18n.locale === 'zh_CN') {
    suffix = 'Sc'
  } else {
    suffix = 'Tc'
  }
  return field + suffix
}

export function initFbSDK (callback) {
  if (!window.FB) {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: process.env.VUE_APP_FACEBOOK_APP_ID,
        cookie: true,
        xfbml: true,
        version: 'v16.0'
      })
    }
    // 创建script标签引入facebook得sdk
    const script = document.createElement('script')
    script.src = 'https://connect.facebook.net/en_US/sdk.js'
    script.onload = () => {
      callback()
    }
    document.head.appendChild(script)
  } else {
    callback()
  }
}

export function FBLogin () {
  return new Promise((resolve, reject) => {
    if (!window.FB) reject(new Error('facebook sdk未加载完'))
    window.FB.login((LoginRes) => {
      if (LoginRes.status === 'connected') {
        resolve(LoginRes)
      } else {
        reject(new Error(LoginRes))
      }
    }, { scope: 'public_profile,email' })
  })
}

export function initGoogleSDK (callback) {
  if (!window.google) {
    const script = document.createElement('script')
    script.src = `https://accounts.google.com/gsi/client?hl=${i18n.locale === 'zh_HK' ? 'zh_TW' : i18n.locale}`
    script.async = true
    script.defer = true
    script.onload = () => {
      callback()
    }
    document.body.appendChild(script)
  } else {
    callback()
  }
}

export function initAppleSDK (callback) {
  if (!window.AppleID) {
    const script = document.createElement('script')
    script.src = `https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/${i18n.locale}/appleid.auth.js`
    script.async = true
    script.defer = true
    script.onload = () => {
      callback()
    }
    document.body.appendChild(script)
  } else {
    callback()
  }
}

export function isApp () {
  return Vue.prototype.$Cookies.get('CL_channel') === 'mobile'
}

/**
 *  根据当前i18n获取 En Sc Tc结尾的field
 * @param {object} obj 获取值的对象
 * @param {string} name field name
 * @param {string} [locale] field name
 * */
export const getUtsvField = (obj, name, locale = i18n.global.locale.value) => {
  let field = name
  switch (i18n.locale) {
    case 'zh_CN':
      field += 'Sc'
      break
    case 'zh_TW':
      field += 'Tc'
      break
    case 'en_US':
      field += 'En'
      break
  }
  return obj[field]
}

/** 获取倒计时时间
 * @param {number} totalMill 总时间的毫秒值
 * @param {number} startMill 起始时间的毫秒值
 * @return {object} 返回毫秒值和字符串 'mm:ss'的字符串
*/
export const getRemainingTime = (totalMill, startMill) => {
  const second = Math.floor((totalMill + startMill - Date.now()) / 1000)
  if (second > 0) {
    const mm = String(Math.floor(second / 60)).padStart(2, 0)
    const ss = String(second % 60).padStart(2, 0)
    return {
      remainingStr: `${mm}:${ss}`,
      remainingMill: second * 1000
    }
  } else {
    throw new Error('倒计时结束了')
  }
}

/** 针对obj的field进行过滤
 * @param {object} obj 需要过滤的对象
 * @param {array} fields 对应的field
 * @param {boolean} bool true表示过滤的数据，false表示保留,默认 true
 */
export const filterFields = (obj, fields, bool = true) => {
  let keys = Object.keys(obj)
  keys = bool ? keys.filter(item => !fields.includes(item)) : keys.filter(item => fields.includes(item))
  const res = {}
  keys.forEach(item => {
    res[item] = obj[item]
  })
  return res
}
